module.exports = "/assets/317793ddb5f7488dfb113e2970f08732.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PR.png
// module id = 1726
// module chunks = 0